import { css } from 'lit'

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`
  
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--sl-font-heading);
    font-weight: 400;
  }  

  /* 
    custom sl-card styles
  */

  sl-card::part(base) {
    box-shadow: none;
    border: none;
    filter: drop-shadow(.5px 1px 1px hsla(0, 0%, 54%, 0.15)) drop-shadow(1px 2px 2px hsl(285deg 40% 40%/.15)) drop-shadow(2px 4px 4px hsla(270, 1%, 49%, 0.15)) drop-shadow(4px 8px 8px hsla(270, 1%, 50%, 0.15)) ;
  }

  sl-card{
    margin-bottom: 30px;
  }

  /* 
    this is a custom "cta" variant of the sl-button.
    it is multiline and adds a "»" at the end of the label 
  */

  sl-button.cta::part(base) {
    padding: var(--sl-spacing-large);
  }

  sl-button.cta::part(label) {
    color: white;
    white-space: pre-line;
    line-height: normal;
    position: relative;
    padding-bottom: 0.7em;
    text-align: left;
  }

  sl-button.cta::part(label)::after {
    content: "»";
    font-size: 1.5em; 
    color: inherit;
    position: absolute;
    bottom: -0.4em;
    left: var(--sl-spacing-large);
  }

`